import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is in the img folder
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.


function OrganizationsPage() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
     
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" id="titulli">purpose at the core</h1>
            <p className="banner-description">
              Craft a mission that resonates with your community, aligns with your goals, and builds strong branding.
            </p>
             <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>


          </div>

        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Premium Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
            
      </div>
      <section className="about-section">
        {/* Section 1: What We Offer */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Define Your Purpose</strong></h2>
            <p>
              Develop a mission statement that clearly communicates your organization's purpose and direction.
            </p>
            <ul>
              <p><strong>Community Engagement:</strong> Involve the community in the process.</p>
              <p><strong>Gather Feedback:</strong> Refine your mission with insights from key stakeholders.</p>
              <p><strong>Brand Alignment:</strong> Ensure your mission aligns with your organizational values.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps6.1.png" alt="Organization Mission" />
          </div>
        </div>

        {/* Section 2: Benefits for NGOs */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Empowering NGOs through Clear Mission Statements</strong></h2>
            <p>
              A clear mission drives growth, attracts support, and enhances public relations for your NGO.
            </p>
            <ul>
              <p><strong>Clarity of Purpose:</strong> Create a roadmap for your organization’s goals.</p>
              <p><strong>Enhanced Public Image:</strong> A strong mission attracts donors and partners.</p>
              <p><strong>Focused Growth:</strong> Align your projects with your core mission.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps6.2.png" alt="NGO Benefits" />
          </div>
        </div>

        {/* Section 3: Success Stories */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Impactful Missions, Transformational Results</strong></h2>
            <p>
              Organizations with well-defined missions experience enhanced engagement and growth.
            </p>
            <a href="/blog" className="cta-button">Read Our Success Stories</a>
          </div>
          <div className="about-image">
            <img src="/img/ps6.3.png" alt="Mission Success" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default OrganizationsPage;
